import EditProfileForm from '@components/profile/EditProfileForm'
import { ModalProps } from '../../types/modal'
import Modal from '../shared/Modal'
import { LinkButton } from '@components/shared/Button'
import { useProfileDetails } from './useProfileDetails'
import { useTranslation } from 'next-i18next'

const EditProfileModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('profile')
  const { profileDetails, loadingProfileDetails } = useProfileDetails()
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="mb-1 text-center">{t('modal.title')}</h2>
      {!loadingProfileDetails && !profileDetails?.username ? (
        <p className="text-center">{t('modal.claim-username')}</p>
      ) : null}
      <EditProfileForm onFinish={onClose} />
      <LinkButton onClick={onClose} className="mx-auto mt-6 font-bold">
        {t('modal.cancel')}
      </LinkButton>
    </Modal>
  )
}

export default EditProfileModal
